/**
 * A chatbot prompt suggestion offered to the user, as returned by
 * GET /api/prompt/suggestions.
 */
export class PromptSuggestion {
  /**
   * @param {Object} [data] - A prompt suggestion from the API.
   * @param {string} [data.name] - Identifies the prompt, sent back with the message.
   * @param {string} [data.text] - The prompt text shown to the user and sent as the message.
   * @param {number} [data.version] - The prompt's version, sent back with the message.
   */
  constructor({ name, text, version } = {}) {
    this.name = name;
    this.text = text;
    this.version = version;
  }
}
